"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBoxDropdown = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
const helpers_js_1 = require("./helpers.js");
exports.ComboBoxDropdown = React.forwardRef((props, forwardedRef) => {
    const { children, ...rest } = props;
    const { isOpen } = (0, index_js_1.useSafeContext)(helpers_js_1.ComboBoxStateContext);
    const dispatch = (0, index_js_1.useSafeContext)(helpers_js_1.ComboBoxActionContext);
    const { inputRef, toggleButtonRef } = (0, index_js_1.useSafeContext)(helpers_js_1.ComboBoxRefsContext);
    // sync internal isOpen state with user's visible prop
    React.useEffect(() => {
        if (props.visible != undefined) {
            dispatch({ type: props.visible ? 'open' : 'close' });
        }
    }, [dispatch, props.visible]);
    return (React.createElement(index_js_1.Popover, { placement: 'bottom-start', visible: isOpen, onClickOutside: React.useCallback((_, { target }) => {
            var _a;
            if (!((_a = toggleButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                dispatch({ type: 'close' });
            }
        }, [dispatch, toggleButtonRef]), animation: 'shift-away', duration: 200, reference: inputRef, ref: forwardedRef, content: children, ...rest }));
});
exports.ComboBoxDropdown.displayName = 'ComboBoxDropdown';
